import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { ParagraphSM, TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { PageSection } from '../../components/PageSection'
import { useTorchApplication } from '../../components/TorchApplicationContext'

export const FilmAcknowledgement = () => {
  const { t } = useTranslate('guild-create')
  const { data, updateData } = useTorchApplication()

  const acknowledged = !!data?.torchAcknowledgement

  const onAcknowledge = () => {
    updateData({ torchAcknowledgement: true })
  }

  return (
    <PageSection className={classNames(!acknowledged && 'border-info-300 bg-info-100')}>
      <TitleMD weight="bold">
        {t('filmCreatorProtectionsAndViewLimitations', 'Film Creator Protections & Viewer Limitations')}
      </TitleMD>
      <ul className="list-inside list-disc">
        <ParagraphSM>
          <li>
            {t(
              'angelFullFilmNotice1',
              'Angel will only show your film to Guild members who have gone through a verification check.',
            )}
          </li>
          <li>
            {t(
              'angelFullFilmNotice2WeekExpire',
              'Angel will only make your film available to viewers for 1 week from the time they start watching it.',
            )}
          </li>
          <li>
            {t('angelFullFilmNotice3', 'Angel will place a visible watermark on the film displaying "Guild Use Only".')}
          </li>
        </ParagraphSM>
      </ul>
      {!acknowledged && (
        <div>
          <Button variant="gray-900" onClick={onAcknowledge}>
            {t('iUnderstand', 'I Understand')}
          </Button>
        </div>
      )}
    </PageSection>
  )
}
